import { mutations } from './mutations';
import { actions } from './actions';
export var state = {
    formTemplates: [],
    loading: false,
};
export var formTemplates = {
    state: state,
    namespaced: true,
    actions: actions,
    mutations: mutations,
};
